var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"clearable":"","disabled":_vm.disabled},on:{"on-query-change":_vm.selChange},model:{value:(_vm.nValue),callback:function ($$v) {_vm.nValue=$$v},expression:"nValue"}},_vm._l((_vm.dictItemList),function(item){return _c('Option',{key:item.dictValue,attrs:{"value":item.dictValue}},[_vm._v(_vm._s(item.dictName))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c80eb33a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/src/select.vue
// module id = null
// module chunks = 